import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { CommonService } from 'src/app/shared/service/common.service';
import { CloudReadinessAssessmentService } from '../cloud-readiness-assessment.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
    selector: 'nio-cloud-readiness-assessment',
    templateUrl: './cloud-readiness-assessment.component.html',
    styleUrls: ['./cloud-readiness-assessment.component.scss'],
    standalone: false
})
export class CloudReadinessAssessmentComponent implements OnInit {
  sections = [];
  form: FormGroup = new FormGroup({});
  activeTabIndex = 0;
  showResults = false;
  token;
  constructor(
    private commonService: CommonService,
    private cloudReadinessAssessmentService: CloudReadinessAssessmentService,
    private router: Router,
    private activeRoute: ActivatedRoute
  ) {
    this.activeRoute.queryParams.subscribe((params) => {
      if (params.token) {
        this.token = params.token;
        console.log('Token from query params:', this.token);
      } else {
        this.commonService.errorMessage(
          'Invalid or missing token in the URL. Please check the link and try again.'
        );
        this.router.navigate(['/']);
      }
    });
  }

  ngOnInit(): void {
    this.getCloudReadinessAssessmentPublicQuestions();
  }

  getCloudReadinessAssessmentPublicQuestions() {
    this.cloudReadinessAssessmentService
      .getCloudReadinessAssessmentPublicQuestions()
      .subscribe(
        (data: any) => {
          console.log('getCloudReadinessAssessmentPublicQuestions', data);
          this.sections = data;
          for (const sec of this.sections) {
            for (const q of sec.questions) {
              // const cached = localStorage.getItem('ans_' + q.id);
              // const val = cached ? JSON.parse(cached) : null;
              const val = null;
              this.form.addControl(q.id, new FormControl(val));
            }
          }
        },
        (err) => {
          if (err?.error?.message) {
            this.commonService.errorMessage(err?.error?.message);
          } else {
            this.commonService.errorMessage(
              'Error while trying to get Assessment questions, Please try again later.'
            );
          }
        }
      );
  }

  get totalQuestions(): number {
    return this.sections.reduce((acc, s) => acc + s.questions.length, 0);
  }

  get answeredCount(): number {
    let count = 0;
    for (const k of Object.keys(this.form.controls)) {
      const v = this.form.get(k)?.value;
      if (v !== null && v !== undefined && v !== '') {
        count++;
      }
    }
    return count;
  }

  get progressPercentage(): number {
    if (this.totalQuestions === 0) {
      return 0;
    } else {
      return Math.round((this.answeredCount / this.totalQuestions) * 100);
    }
  }

  onAnswerChange(sectionId: string, questionId: string) {
    const val = this.form.get(questionId)?.value;
    // localStorage.setItem('ans_' + questionId, JSON.stringify(val));
  }

  nextSection() {
    if (this.activeTabIndex < this.sections.length - 1) {
      this.activeTabIndex++;
    }
  }

  prevSection() {
    if (this.activeTabIndex > 0) {
      this.activeTabIndex--;
    }
  }

  goToNextUnanswered() {
    const section = this.sections[this.activeTabIndex];
    for (const q of section.questions) {
      const v = this.form.get(q.id)?.value;
      if (v === null || v === undefined || v === '') {
        const el = document.getElementById('q-' + q.id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          el.classList.add('highlight');
          setTimeout(() => el.classList.remove('highlight'), 1400);
        }
        return;
      }
    }
    if (this.activeTabIndex < this.sections.length - 1) {
      this.nextSection();
    }
  }

  toggleResults() {
    // this.showResults = !this.showResults;
    if (this.answeredCount < this.totalQuestions) {
      this.commonService.errorMessage(
        'Please answer all the questions before submitting the assessment.'
      );
      return;
    }
    let answers = this.answersJson;
    console.log('Assessment answers:', answers);
    if (this.token) {
      answers = JSON.stringify({
        token: this.token,
        answers: JSON.parse(answers),
      });
    }
    console.log('Assessment answers payload:', answers);
    this.cloudReadinessAssessmentService
      .saveCloudAssessmentAnswers(answers)
      .subscribe(
        (data: any) => {
          console.log('saveCloudAssessmentAnswers', data);
          // this.cloudReadinessAssessmentService.questionsAnswers = data;
          this.router.navigate(['/assessment/report/' + data.token]);
        },
        (err) => {
          if (err?.error?.message) {
            this.commonService.errorMessage(err?.error?.message);
          } else {
            this.commonService.errorMessage(
              'Error while trying to save assessment answers, Please try again later.'
            );
          }
        }
      );
  }

  get answersJson(): string {
    const out: any = {};
    for (const sec of this.sections) {
      out[sec.id] = {};
      for (const q of sec.questions) {
        out[sec.id][q.id] = this.form.get(q.id)?.value ?? null;
      }
    }
    return JSON.stringify(out, null, 2);
  }

  exportResults() {
    const blob = new Blob([this.answersJson], { type: 'application/json' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'assessment-answers.json';
    a.click();
    URL.revokeObjectURL(a.href);
  }

  clearAnswers() {
    for (const k of Object.keys(this.form.controls)) {
      this.form.get(k)?.setValue(null);
      // localStorage.removeItem('ans_' + k);
    }
  }
}
